import UserPage from './UserPage';
import PostListState from '../states/PostListState';
import PostList from './PostList';

/**
 * The `PostsUserPage` component shows a user's activity feed inside of their
 * profile.
 */
export default class PostsUserPage extends UserPage {
  /**
   * The state of the Post models in the feed.
   */

  /**
   * The number of activity items to load per request.
   */
  loadLimit = 20;
  oninit(vnode) {
    super.oninit(vnode);
    this.posts = new PostListState({}, this.loadLimit);
    this.loadUser(m.route.param('username'));
  }
  content() {
    return m("div", {
      className: "PostsUserPage"
    }, m(PostList, {
      state: this.posts
    }));
  }

  /**
   * Initialize the component with a user, and trigger the loading of their
   * activity feed.
   */
  show(user) {
    super.show(user);
    this.posts.refreshParams(this.params(user), 1);
  }
  params(user) {
    return {
      filter: {
        author: user.slug()
      }
    };
  }
}
flarum.reg.add('core', 'forum/components/PostsUserPage', PostsUserPage);